module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"discussion":"Discussion","newMessage":"New message"},"fr":{"discussion":"Discussion","newMessage":"Nouveau message"}}')
  delete Component.options._Ctor
}
